import { useReducer, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';

import { setStoreHistory } from "../actions/index";

const historyReducer = (state, action) => {
  switch(action.type) {
    case 'prev':
      const indexPrev = state.findIndex(x => x.active) - 1;
      action.navigate(state[indexPrev].path);
      return [...state.map( (x,i) => { x.active = (indexPrev === i); return x }) ]
    case 'next':
      const indexNext = state.findIndex(x => x.active) + 1;
      action.navigate(state[indexNext].path);
      return [...state.map( (x,i) => { x.active = (indexNext === i); return x }) ]
    case 'update':
      const index = state.findIndex(x => x.active);
      return [...state.slice(0, index + 1).map( x => { x.active = false; return x; }), { path: action.path, active: true }]
    case 'delete':
      const last = state.findIndex(x => x.active);
      return [...state.slice(0, last).map( x => { x.active = false; return x; }), { path: `/`, active: true }]
    default:
      return state;
  }
}

const useStoreHistory = (path = `/`) => {
  const dispatch = useDispatch();
  const [history, dispatchHistory] = useReducer(historyReducer, [{ path, active: true }]);
  let store = {
    history,
    prev: (navigate) => dispatchHistory({type: `prev`, navigate}),
    next: (navigate) => dispatchHistory({type: `next`, navigate}),
    updateHistory: (path) => dispatchHistory({type: `update`, path}),
    deleteLastHistory: () => dispatchHistory({type: `delete`})
  };
  useEffect(() => {
    dispatch(setStoreHistory(store));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, dispatch]);

  //V1 Side-channel (replace setTimeout reducer UPDATE_STORE_HISTORY).
  const pendingHistoryPath = useSelector(s => s.pendingHistoryPath);
  const lastHistoryAt = useRef(null);
  useEffect(() => {
    if (pendingHistoryPath && pendingHistoryPath.at !== lastHistoryAt.current) {
      lastHistoryAt.current = pendingHistoryPath.at;
      store.updateHistory(pendingHistoryPath.path);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingHistoryPath]);

  return store;
};

export default useStoreHistory;
